import { useEffect } from 'react'
import { useAuth } from 'lib/auth'
import { LoadingScreen } from 'components/LoadingScreen'

export default function LogoutPage() {
  const { service } = useAuth()

  useEffect(() => {
    service.startSignOut()
  }, [service])

  return (
    <LoadingScreen title="Logging out..." />
  )
}